module.exports = __webpack_public_path__ + "img/envelope-at-fill.f4b0a147.svg";